<template>
  <div class="tagGroup">
    <div class="search">
      <div class="flex-center margin-bot">
        <van-search class="flex1" v-model="tagName" placeholder="搜索企业标签" @clear="searchCustomer" />
        <span :span="4" class="search-text" @click="searchCustomer">搜索</span>
      </div>
    </div>
    <div class="tag_wrap">
      <div v-for="item in tagOption" :key="item.group_id" class="tagItem">
        <h3>{{ item.group_name }}</h3>
        <div class="tag-list-dropdown">
          <span v-for="tag in item.tag" :key="tag.id" @click="selectLabel(tag)" :class="{ activetag: isInclude(selectArr, tag) }"> {{ tag.name }}</span>
        </div>
      </div>
    </div>
    <div class="fixed_bottom fixed_horizo_center">
      <div class="button_bottom">
        <dl @click="resetTag" ref="resetBtn">返回</dl>
        <dl @click="ensureComfirm" ref="ensureConfirm">
          <span>确认</span><span v-show="selectArr.length > 0">{{ "(" + selectArr.length + ")" }}</span>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  listGroupTag,
  // config,
  // AgentConfigUrl,
} from "@/server/api.js";
import { wxConfig } from "../fastReply/js/config";
import {toLogin} from "../../utils/public";

export default {
  name: "tagGroup",
  data() {
    return {
      status: 0,
      tag: "",
      tagOption: [],
      selectArr: [],
      formatTags: [],
      total: 0, // 总条数
      tagIds: [],
      tagName: "",
      userInfo: {},
    };
  },
  props: ["checkedTag", "isShow", "appName"],
  created() {
    this.getTagList();
  },
  watch: {
    // "$store.state.tokenFlag": function (newval) {
    //   if (newval) {
    //       this.getTagList();
    //   }
    // },
    selectArr(val) {
      if (this.appName == "student") {
        this.$refs.resetBtn.classList.add("resetTag");
        this.$refs.resetBtn.innerHTML = "取消";
        this.$refs.ensureConfirm.style.opacity = 1;
      } else if (val.length > 0 && this.appName !== "appName") {
        this.$refs.resetBtn.classList.add("resetTag");
        this.$refs.resetBtn.innerHTML = "重置";
        this.$refs.ensureConfirm.style.opacity = 1;
      } else {
        this.$refs.resetBtn.classList.remove("resetTag");
        this.$refs.resetBtn.innerHTML = "返回";
        this.$refs.ensureConfirm.style.opacity = 0.5;
      }
    },
    isShow(val) {
      if (val) {
        console.log(val, 1);
        this.selectArr = [...this.checkedTag];
      }
    },
  },
  methods: {
    async getTagList() {
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      //判断如果登录了就请求标签列表
      if (this.userInfo && this.userInfo?.zsGroupId) {
        this.getTag();
      }else{
        //调用login进行登录
        this.toLogin();
        this.getTag();
      }
    },

    async getTag(){
      let params = {
        deptId: this.userInfo?.zsGroupId,
      };
      const res = await listGroupTag(params);
      if (res.code !== "200") return Toast.fail(res.msg);
      this.tagOption = res.data.tagGroups.reverse();
      this.formatTags = [...this.tagOption];
    },

    initS() {
      if (this.appName == "student") {
        this.$refs.resetBtn.classList.add("resetTag");
        this.$refs.resetBtn.innerHTML = "取消";
        this.$refs.ensureConfirm.style.opacity = 1;
      } else if (this.selectArr.length > 0) {
        this.$refs.resetBtn.classList.add("resetTag");
        this.$refs.resetBtn.innerHTML = "重置";
        this.$refs.ensureConfirm.style.opacity = 1;
      } else {
        this.$refs.resetBtn.classList.remove("resetTag");
        this.$refs.resetBtn.innerHTML = "取消";
        this.$refs.ensureConfirm.style.opacity = 0.5;
      }
    },

    searchCustomer() {
      if (!this.tagName) {
        return (this.tagOption = [...this.formatTags]);
      }
      let newarr = [];
      // console.log(state.deparmentList)
      this.formatTags.map((item) => {
        if (item.group_name.indexOf(this.tagName) > -1) {
          newarr.push(item);
        }
        item.tag.filter((j) => {
          if (j.name.indexOf(this.tagName) > -1) {
            newarr.push(item);
          }
        });
      });
      this.tagOption = [...new Set(newarr)];
    },

    ensureComfirm() {
      console.log(this.selectArr);
      if (this.selectArr.length > 0 || this.appName == "student") {
        this.$emit("appendTag", this.selectArr, false);
        //this.$store.commit('selectTags',this.selectArr);
        //this.$router.push('customerGroup');
      } else {
        return false;
      }
    },

    resetTag(e) {
      let target = e.target;
      if (this.appName == "student") {
        return this.$emit("cancelTag", false);
      }
      if (this.selectArr.join("")) {
        this.selectArr = [];
        target.classList.remove("resetTag");
      } else {
        //this.$store.commit('selectTags',this.selectArr);
        // this.$router.push('customerGroup');
        this.$emit("appendTag", this.selectArr, false);
        // this.$emit("cancelTag", this.selectArr, false);
      }
    },

    //是否选中
    isInclude(arr, label) {
      return arr.find((item) => {
        return item.id == label.id;
      });
    },
    selectLabel(label) {
      this.chooseSelectLabel(this.selectArr, label);
    },
    //选择标签操作
    chooseSelectLabel(arr, label) {
      let index = arr.findIndex((val) => {
        return val.id === label.id;
      });
      //  console.log(index);
      if (index > -1) {
        arr.splice(index, 1);
      } else {
        arr.push(label);
      }
      return arr;
    },
  },
  mounted() {
    this.initS();
  },
};
</script>

<style lang="less" scoped>
.tagGroup {
  width: 100%;
  min-height: 100%;
  background: #f6f6f6;
  padding-top: 124px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  .fixed_bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #f6f6f6;
    width: 100%;
  }

  .van-search {
    padding: 0;

    /deep/ .van-icon-search {
      font-size: 30px;
    }

    /deep/ .van-field__control {
      font-size: 28px;
    }
  }

  .van-search__content {
    height: 80px;
    padding-left: 30px;
    border-radius: 40px;
    background-color: #f3f3f3;
  }

  .van-search .van-cell {
    align-items: center;
  }

  .van-field__left-icon {
    height: 80px;
  }
  .tag_wrap {
    padding: 20px 30px;
    margin-bottom: 122px;
    .tagItem {
      margin-bottom: 18px;
      background-color: #ffffff;
      border-radius: 14px;
      padding: 24px;
      h3 {
        font-size: 32px;
        color: #333333;
      }
      .tag-list-dropdown {
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        span {
          background-color: #f2f2f2;
          padding: 9px 21px;
          color: #999999;
          border-radius: 8px;
          margin: 0 20px 20px 0;
          font-size: 24px;
          border: 1px solid #f2f2f2;
        }
        .activetag {
          color: #277fff;
          border: 1px solid #a5caff;
          background: #e0edff;
        }
      }
    }
  }

  .search-text {
    font-size: 32px;
    padding-left: 20px;
    cursor: pointer;
  }

  .search {
    padding: 20px 30px 10px;
    background: #fff;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;

    .margin-bot {
      margin-bottom: 16px;
    }
  }
}
</style>
